module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('nav', {
    class: {
      sticky: this.$store.getters.sticky
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("../../assets/resources/img/ihd-logo-white.png"),
      "alt": "ihd logo"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "logo-black",
    attrs: {
      "src": require("../../assets/resources/img/ihd-logo.png"),
      "alt": "ihd logo"
    }
  }), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.windowWidth || _vm.stack_nav),
      expression: "windowWidth || stack_nav"
    }],
    staticClass: "main-nav"
  }, [_c('li', [_c('a', {
    directives: [{
      name: "smooth-scroll",
      rawName: "v-smooth-scroll",
      value: ({
        duration: 800
      }),
      expression: "{duration: 800}"
    }],
    attrs: {
      "href": "#features"
    }
  }, [_vm._v("项目")])]), _vm._v(" "), _c('li', [_c('a', {
    directives: [{
      name: "smooth-scroll",
      rawName: "v-smooth-scroll",
      value: ({
        duration: 800
      }),
      expression: "{duration: 800}"
    }],
    attrs: {
      "href": "#skills"
    }
  }, [_vm._v("技能")])]), _vm._v(" "), _c('li', [_c('a', {
    directives: [{
      name: "smooth-scroll",
      rawName: "v-smooth-scroll",
      value: ({
        duration: 800
      }),
      expression: "{duration: 800}"
    }],
    attrs: {
      "href": "#schedule"
    }
  }, [_vm._v("日程")])]), _vm._v(" "), _c('li', [_c('a', {
    directives: [{
      name: "smooth-scroll",
      rawName: "v-smooth-scroll",
      value: ({
        duration: 800
      }),
      expression: "{duration: 800}"
    }],
    attrs: {
      "href": "#companies"
    }
  }, [_vm._v("合作公司")])]), _vm._v(" "), _c('li', [_c('a', {
    directives: [{
      name: "smooth-scroll",
      rawName: "v-smooth-scroll",
      value: ({
        duration: 800
      }),
      expression: "{duration: 800}"
    }],
    attrs: {
      "href": "#contact-form"
    }
  }, [_vm._v("加入")])])]), _vm._v(" "), _c('a', {
    staticClass: "mobile-nav-icon",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.stack_nav = !_vm.stack_nav
      }
    }
  }, [_c('i', {
    class: {
      'ion-navicon-round': !_vm.stack_nav, 'ion-close-round': _vm.stack_nav
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "hero-text-box"
  }, [_c('h1', [_c('vue-typer', {
    attrs: {
      "text": "International Horizon Developer",
      "caret-animation": "smooth",
      "type-delay": "160",
      "repeat": 0
    }
  }), _c('br')], 1), _vm._v(" "), _c('h1', {
    staticClass: "fixed-line-height"
  }, [_c('vue-typer', {
    attrs: {
      "text": "为你提供最好的职场技能培训",
      "caret-animation": "smooth",
      "type-delay": "160",
      "repeat": 0,
      "pre-type-delay": "5500"
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    directives: [{
      name: "smooth-scroll",
      rawName: "v-smooth-scroll",
      value: ({
        duration: 800
      }),
      expression: "{duration: 800}"
    }],
    staticClass: "btn btn-full",
    attrs: {
      "href": "#contact-form"
    }
  }, [_vm._v("Join us")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-ghost",
    attrs: {
      "href": "https://firebasestorage.googleapis.com/v0/b/ihd-official-website.appspot.com/o/pdf%2Fihdintro.pdf?alt=media&token=b25185c8-dcae-47bf-a4c3-274457968538",
      "download": "https://firebasestorage.googleapis.com/v0/b/ihd-official-website.appspot.com/o/pdf%2Fihdintro.pdf?alt=media&token=b25185c8-dcae-47bf-a4c3-274457968538"
    }
  }, [_vm._v("Show me more")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-57f48560"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sections/Header.vue
// module id = 102
// module chunks = 0